/** Экономика, Stars, штаб. */
import { AttackDef } from "./core";
import { Coins, Permille, PermilleAny, PosInt, UInt } from "../common";
import { z } from "zod";

/** Звёзды героя (вкладка Stars). */
export const StarsDef = z.object({
  /** Уровни героя, на которых открывается покупка звезды k (5 значений: 10/20/30/40/50). */
  levels: z.array(PosInt).length(5),
  /** Цена звезды k (5 значений). */
  costs: z.array(Coins).length(5),
  /** Прибавка урона за звезду, промилле (250 = +25 %). */
  damagePerStarPermille: UInt,
});
export type StarsDef = z.infer<typeof StarsDef>;

/** Экономика: награды, офлайн-доход, звёзды. */
export const EconomyDef = z.object({
  /** Монеты за пройденную волну: `base + perWave · (wave − 1)`. */
  waveReward: z.object({
    base: Coins,
    perWave: Coins,
    bossBonusPermille: PermilleAny,
    /**
     * Награда в поздних волнах растёт геометрически (нет — линейно на всех волнах): с `fromWave` каждая следующая волна
     * платит на `growthPermille` ‰ больше предыдущей. Цены Level/Tech растут геометрически, линейный доход их не догонял.
     */
    lateGrowth: z
      .object({
        fromWave: PosInt,
        growthPermille: PermilleAny,
        /** С этой волны рост медленнее (нет — один темп до потолка): тормоз длинных забежек (ISSUE-69). */
        softFromWave: PosInt.optional(),
        softGrowthPermille: PermilleAny.optional(),
      })
      .optional(),
  }),
  /** Офлайн-доход: доля темпа последней пройденной волны и потолок. */
  offline: z.object({
    /** 500 = 50 % темпа. */
    ratePermille: Permille,
    /** Базовый потолок, секунд (8 ч = 28 800). */
    capSeconds: PosInt,
    /** Меньше этого — окно «с возвращением» не показываем. */
    minSeconds: UInt,
  }),
  stars: StarsDef,
  /** Стартовые монеты нового игрока. */
  startCoins: Coins,
});
export type EconomyDef = z.infer<typeof EconomyDef>;

/** Штаб и его пушка на старте (до Tech). */
export const HqDef = z.object({
  hp: PosInt,
  regenPerTick: UInt,
  cannon: AttackDef,
});
export type HqDef = z.infer<typeof HqDef>;
